import { NavLink, Outlet } from 'react-router-dom'

const SECTIONS = [
  { to: '/admin', label: 'Board', end: true },
  { to: '/admin/notes', label: 'Updates' },
  { to: '/admin/timesheet', label: 'Hours' },
  { to: '/admin/schedules', label: 'Reminders' },
  { to: '/admin/people', label: 'Crew' },
  { to: '/admin/sites', label: 'Sites' },
  { to: '/admin/inventory', label: 'Gear' },
  { to: '/admin/export', label: 'Export' },
  { to: '/admin/settings', label: 'Setup' },
]

export default function AdminLayout() {
  return (
    <div className="space-y-5">
      <header>
        <p className="label">Office</p>
        <h1 className="mt-0.5 text-2xl">Admin</h1>
      </header>

      <nav className="scroll-x -mx-4 border-b border-line px-4" aria-label="Admin sections">
        <div className="flex min-w-max gap-1">
          {SECTIONS.map((section) => (
            <NavLink
              key={section.to}
              to={section.to}
              end={section.end}
              className={({ isActive }) =>
                // No negative bottom margin: this strip is a scroll container, so
                // pulling the indicator over the nav's rule only gets it clipped.
                `flex min-h-12 items-center whitespace-nowrap border-b-3 px-3 text-sm font-bold ${
                  isActive ? 'border-brand text-graphite' : 'border-transparent text-graphite-2'
                }`
              }
            >
              {section.label}
            </NavLink>
          ))}
        </div>
      </nav>

      <Outlet />
    </div>
  )
}
